/* eslint-disable import/no-cycle */
// Store functionality
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  posts: [],
  userWall: [],
  memberWall: []
};

// Create a new store
const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
